import location from "../models/location";

export const types = {
  LOCATION_REQUESTED: "LOCATION_REQUESTED",
  LOCATION_SUCCEDDED: "LOCATION_SUCCEDDED",
  LOCATION_FAILED: "LOCATION_FAILED"
};

export const actions = {
  requestLocation: () => {
    return { type: types.LOCATION_REQUESTED };
  }
};

const reducer = (state = location, action) => {
  switch (action.type) {
    case types.LOCATION_SUCCEDDED:
      return {
        ...state,
        ...action.value,
        requesting: false,
        locationSet: true
      };
    case types.LOCATION_FAILED:
      return {
        ...state,
        ...location,
        locationSet: true
      };
    default:
      return state;
  }
};

export default reducer;
